<template>
  <form ref="form" class="login__form" @submit.prevent="valid() ? login() : null" novalidate>
    <sc-field>
      <sc-input type="email" name="email" ref="email" placeholder="Informe seu e-mail" v-model="form.email" readonly
        disabled :value="email" @blur="$emit('update:email', form.email)" required />
    </sc-field>

    <sc-field :addons="false">
      <sc-input type="password" name="password" ref="password" placeholder="Informe sua senha" autocorrect="off"
        autocapitalize="off" autocomplete="off" password-reveal icon-pack="fa" v-model="form.password" required />
      <p class="help">
        <a href @click.prevent="$emit('update:isForgetPassword', true)">Esqueceu sua senha?</a>
      </p>
    </sc-field>

    <div class="login__switchbox">
      <sc-switch class="login__switchbox-switch" size="is-small" @change.native="changeSaveEmail"
        v-model="form.saveEmail">
        Salvar email
      </sc-switch>
      <sc-switch class="login__switchbox-switch" size="is-small" v-model="form.persistData">
        Permanecer logado ?
      </sc-switch>
    </div>

    <sc-field>
      <sc-button type="submit" theme="primary" class="is-fullwidth" text="Entrar" :loading="loading" />
    </sc-field>

    <sc-field>
      <sc-button class="is-fullwidth button-back" text="Voltar" :disabled="loading" @click="$emit('goBackToEmailCheck');" />
    </sc-field>
  </form>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    Storage,
    Auth,
    Moment,
  } from '@intelipost-js/secure-providers';

  import {
    ScField,
    ScSwitch,
    ScInput,
    ScButton,
  } from '@intelipost-js/secure-components';

  const { mapActions, mapMutations } = createNamespacedHelpers('auth');
  export default {
    name: 'form-login',
    props: {
      email: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        loading: false,
        storageEmailKey: 'lastEmail',
        form: {
          email: null,
          password: null,
          saveEmail: false,
          persistData: false,
        },
        fixedStartDate: Moment('01/10/2020 00:00', 'DD/MM/YYYY HH:mm').toISOString(),
      };
    },
    computed: {
      getdiffdays() {
        return Moment().diff(this.fixedStartDate, 'days');
      },
    },
    methods: {
      ...mapActions([
        'getLogin',
        'getLoginCiashop',
      ]),
      ...mapMutations([
        'setExpiredDays',
      ]),
      login() {
        let params = this.form;
        const { code, shop } = this.$route.query;
        this.loading = true;
        if (!!code && !!shop) {
          params = Object.assign({}, params, this.$route.query);
          this.sendLoginCiashop(params);
        } else {
          this.sendLogin(params);
        }
      },
      sendLogin(params) {
        if (this.form.persistData) {
          Storage.set('persistData', 'local', 'local');
        } else {
          Storage.remove('persistData', 'local');
        }
        Storage.set('originMenu', 'newmenu', 'local');
        if (this.getdiffdays <= 90) {
          Storage.set('originMenu', 'oldmenu', 'local');
        }
        return this.getLogin(params).then(({ client = {}, user = {}, authf2 }) => {
          if (authf2) {
            this.$emit('update:email', this.form.email);
            this.$emit('update:saveEmail', this.form.saveEmail);
            this.$emit('update:isTwoFactorAuth', authf2);
            return false;
          }
          if (user.blocked) {
            this.$emit('update:isBlocked', user.blocked);
            this.$emit('update:isForgetPassword', true);
            return false;
          }
          const {
            sandbox_id = null,
            id: client_id = null,
          } = client;

          this.sendHOTJARUserAttributes(client_id, this.form.email);
          this.sendKMAttributes(this.form.email, client_id);

          const { security } = user;
          const isMigrated = Storage.get('userMigrated', 'local');
          if (isMigrated) {
            Auth.updateUser(Object.assign(user, {
              client_id,
              sandbox_id,
              security: {
                ...security,
                session_start: Moment(),
              },
            }));
          } else {
            Auth.updateUser(Object.assign(user, {
              client_id,
              sandbox_id,
            }));
          }
          this.$store.dispatch('notifications/getNotifications')
            .then(() => this.logUser());
          return Auth.setMenu();
        })
          .catch(() => { this.loading = false; });
      },
      sendHOTJARUserAttributes(userID, email) {
        window.hj('identify', userID, {
          email,
        });
      },
      sendKMAttributes(email, userID) {
        _kmq.push(['identify', email]);//eslint-disable-line
        _kmq.push(['set', { 'userID': userID }]);//eslint-disable-line
      },
      sendLoginCiashop(params) {
        return this.getLoginCiashop(params).then(({ client = {}, user = {} }) => {
          const {
            sandbox_id = null,
            id: client_id = null,
          } = client;
          Auth.updateUser(Object.assign(user, {
            client_id,
            sandbox_id,
          }));
          Storage.set('originMenu', 'newmenu', 'local');
          if (this.getdiffdays <= 90) {
            Storage.set('originMenu', 'oldmenu', 'local');
          }
          return Auth.setMenu();
        })
          .then(() => this.$store.dispatch('notifications/getNotifications'))
          .then(() => this.logUser())
          .catch(() => { this.loading = false; });
      },
      valid() {
        const { email, password } = this.$refs;
        return email.checkHtml5Validity() && password.checkHtml5Validity();
      },
      logUser() {
        this.loading = false;

        if (this.form.saveEmail) {
          Storage.set(this.storageEmailKey, this.form.email);
        } else {
          Storage.remove(this.storageEmailKey);
        }

        Storage.set('RemoteAccess', { status: false });

        const userData = Storage.get('user', this.form.persistData ? 'local' : 'session');

        let path;
        let expiredDays;

        if (userData.security) {
          expiredDays = userData.security.expired_password_in_days;
        }

        if (expiredDays <= 5) {
          path = '/user/expired_password';

          const isMigrated = Storage.get('userMigrated', 'local');

          if (expiredDays < 0) {
            if (isMigrated) {
              userData.access_token = null;
            } else {
              userData.token = null;
            }
          }

          Storage.set('user', userData, this.form.persistData ? 'local' : 'session');

          this.setExpiredDays({
            days: expiredDays,
            status: expiredDays < 0,
          });
        } else {
          path = this.$route.query.redirect || '/welcome';
        }

        this.$router.push({ path });
      },
      changeSaveEmail() {
        this.$emit('update:saveEmail', this.form.saveEmail);
      },
    },
    created() {
      this.form.email = this.email;
      this.form.saveEmail = !!this.form.email;
      this.$emit('update:saveEmail', this.form.saveEmail);
      this.$emit('update:email', this.form.email);
      const migratedEmailForget = this.$cookies.get('migrated_email_forget');
      if (migratedEmailForget) {
        this.$emit('update:isForgetPassword', true);
      }
    },
    components: {
      ScField,
      ScSwitch,
      ScInput,
      ScButton,
    },
  };
</script>

<style lang="scss" scoped>
  .login__switchbox {
      display: flex;
      flex-direction: column;
      margin-bottom: 1.5rem;

      &-switch {
        margin: 0 0 .5rem 0;
      }
  }
  .button-back {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/features/public/login/default/forms/FormLogin.vue?b8ff0c46